module.exports = __webpack_public_path__ + "3ef07b8d65d51cd8005716163a45aee3.MP3";